// Old kiosk browsers (e.g. ARM Chromeboxes stuck on Chrome 92) predate
// AbortSignal.timeout (Chrome 103); without it every fetch throws and the
// screen falls back to placeholder config forever
if (typeof AbortSignal.timeout !== "function") {
  AbortSignal.timeout = (ms: number) => {
    const controller = new AbortController();
    setTimeout(
      () => controller.abort(new DOMException("Timed out", "TimeoutError")),
      ms,
    );
    return controller.signal;
  };
}

export {};
